/**
 * @generated SignedSource<<53f3905ca8a19625cdfd29321a711c3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type TimerContentPanelFragment$data = {
  readonly status: JobStatusEnum | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TimerContentLeftDetailsFragment" | "TimerContentRightDetailsFragment" | "TimerContentStatusBadgeFragment" | "TimerContentUpdateInputFragment">;
  readonly " $fragmentType": "TimerContentPanelFragment";
};
export type TimerContentPanelFragment$key = {
  readonly " $data"?: TimerContentPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimerContentPanelFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimerContentPanelFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimerContentLeftDetailsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimerContentRightDetailsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimerContentStatusBadgeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimerContentUpdateInputFragment"
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};

(node as any).hash = "3839f1175805106a458733a6bec9622d";

export default node;
